import PropTypes from 'prop-types';

import Avatar from 'core/components/Avatar';
import Link from 'core/components/Link';
import EmptyWrapper from 'core/components/EmptyWrapper';

import { resolveScopedStyles } from 'core/utils/styled-jsx';
import themePropTypes from 'core/utils/prop-types/theme';

import styles from './index.styl';


function UserInfoProfile(props, context) {
  const {
    theme,
    isDesktop,
    user,
    asDropdown,
    location: {
      pathname,
    },
  } = props;

  const {
    colors,
    animations,
    controls: {
      shapka: shapkaStyles,
      personal: {
        profileAvatar: {
          isCircular,
        },
      },
    },
  } = theme;

  const {
    features: {
      enableUgc,
    },
  } = context;

  const { display_name: name, avatar } = user?.userInfo?.display || {};
  const avatarUrl = avatar?.url;

  const isMobileProfile = !isDesktop && pathname.indexOf('/profile') === 0;

  const Wrapper = asDropdown ? EmptyWrapper : Link;

  const scope = resolveScopedStyles(
    <scope>
      <style jsx>{`
        .linkProfile
          text-decoration ${shapkaStyles.link.idle.decoration}
          color ${shapkaStyles.link.idle.color}
          transition color ${animations.hover}
          :hover
            text-decoration ${shapkaStyles.link.hover.decoration}
            color ${shapkaStyles.link.hover.color}
          :active
            text-decoration ${shapkaStyles.link.active.decoration}
            color ${shapkaStyles.link.active.color}

        .${styles.outlined}
          outline 2px solid ${colors.primary}
      `}
      </style>
    </scope>
  );

  return (
    <Wrapper
      to='/profile'
      type='blank'
      className={scope.wrapClassNames('linkProfile')}
    >
      <style jsx>{`
        .${styles.nameProfile}
          font ${shapkaStyles.link.font}
          letter-spacing ${shapkaStyles.link.letterSpacing}
        .${styles.wrapperAvatar}
          margin-right ${isDesktop ? '10px' : '0'}
      `}
      </style>
      <div className={styles.nameProfile}>
        <div className={scope.wrapClassNames(
          styles.wrapperAvatar,
          isMobileProfile && !enableUgc ? styles.outlined : ''
        )}
        >
          <Avatar
            url={avatarUrl}
            size={28}
            isCircular={isCircular}
          />
        </div>
        {(name && isDesktop) && name.toLowerCase()}
      </div>
      <scope.styles />
    </Wrapper>
  );
}

const linkContract = '{color, decoration}';

UserInfoProfile.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  asDropdown: PropTypes.bool,
  user: PropTypes.shape({
    notify: PropTypes.bool,
    userInfo: PropTypes.object,
    isAuthorized: PropTypes.bool,
  }),
  theme: themePropTypes(`{
    colors: {
      primary,
    },
    controls: {
      shapka: {
        link: {
          idle: ${linkContract},
        },
      },
    },
    animations: {
      hover
    },
  }`),
  isDesktop: PropTypes.bool,
};

UserInfoProfile.contextTypes = {
  features: PropTypes.object,
};


export default UserInfoProfile;

